import $ from 'jquery';
import _ from 'underscore';
import BaseInput from 'source/lib/component/input/base';
import Settings from 'source/lib/settings_model';
import messages from 'messages';

import template from './template.html';

const PasswordInput = BaseInput.extend({
    name: 'password-input',
    template,

    render() {
        const parent = {
            'parent-uId': this.uId || '',
            'parent-name': this.name || '',
        };
        const context = _.extend({ msgs: messages }, Settings.get(), this.data, parent);
        const rendered = this.template(context);
        const $el = $(rendered);

        this.$el.replaceWith($el);
        this.setElement($el);
        return rendered;
    },
});

export default PasswordInput;
